import { assertNever } from '#pplx/frontend/common/type_utils/unreachableValue.js';
import { PROMPT_HISTORY_MAX_LENGTH } from '#pplx/frontend/composer-sdk-plugins/prompt-history/types.js';
export const EMPTY_PROMPT_HISTORY_SELECTION = {
    selectedIndex: null,
    detached: false,
};
/** Removes blanks and adjacent duplicates using the caller's text projection, retaining values. */
export function preparePromptHistoryValues(history, toPlainText) {
    const preparedHistory = [];
    let previousPrompt = null;
    for (const value of history) {
        const prompt = toPlainText(value);
        if (prompt.trim() === '' || prompt === previousPrompt)
            continue;
        preparedHistory.push(value);
        previousPrompt = prompt;
        if (preparedHistory.length >= PROMPT_HISTORY_MAX_LENGTH)
            break;
    }
    return preparedHistory;
}
export function isPromptHistorySelectionActive(state) {
    return state.selectedIndex !== null && !state.detached;
}
/**
 * Returns the next index, `null` to clear, or `undefined` to leave the key unhandled.
 * Adapters validate the selected value before committing the transition.
 */
export function navigatePromptHistorySelection(direction, historySize, state, canNavigate) {
    if (historySize === 0 || !canNavigate)
        return undefined;
    switch (direction) {
        case 'up':
            return Math.min((state.selectedIndex ?? -1) + 1, historySize - 1);
        case 'down':
            if (state.selectedIndex === null)
                return undefined;
            return state.selectedIndex === 0 ? null : state.selectedIndex - 1;
        default:
            assertNever(direction);
            return undefined;
    }
}
/** Detaches once per selection so edited drafts retain native keyboard behavior. */
export function detachPromptHistory(state, historySize) {
    if (!isPromptHistorySelectionActive(state))
        return { state };
    return {
        state: { ...state, detached: true },
        event: { action: 'detached_by_edit', selectedIndex: state.selectedIndex, historySize },
    };
}
/** Attributes a matching selection without resetting it; callers own accepted-submit timing. */
export function getPromptHistorySubmissionEvent(state, historySize, matchesSelection) {
    if (!isPromptHistorySelectionActive(state) || !matchesSelection)
        return undefined;
    return { action: 'submitted', selectedIndex: state.selectedIndex, historySize };
}
//# sourceMappingURL=promptHistoryMechanics.js.map